export default __webpack_public_path__ + "static/heattech_homepage_2-f11c1e6aa9f84c9f3a86677f14045c97.png";